import {inject, Injectable, Service} from '@angular/core';
import { HttpService } from './http.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
 // import { environment } from 'src/environments/environment';

@Service()
export class PublicService {
  // private apiUrl = environment.baseUrl;
  private http = inject(HttpService);

  getRegionList(){
    return this.http.get(`admin/chart-parameters/regions`)
  }

  getCities(regionId: number): Observable<any> {
    return this.http.get(`admin/transactions/cities-by-region?region_id=${regionId}`);
  }

  getDistricts(cityId: number): Observable<any> {
   return this.http.get(`admin/transactions/districts-by-city?city_id=${cityId}`);
  }

}
